import { View, Text } from 'react-native';
import React from 'react';
import { styles } from '../utils/styles';
import { FONT_REGULAR, getColor } from '../utils/theme';
import { goBackTo, height } from '../utils/utils';
import { useTranslation } from 'react-i18next';
import { IModalProps } from './IModalProps';
import { useState } from 'react';
import User from '../object/User';
import { UserIcon } from 'react-native-heroicons/solid';
import { post } from '../utils/http';
import { HTTPUtils } from 'mp-ts-http';
import { ToastManager } from '../component/toast/ToastManager';
import { Toast } from '../component/toast/Toast';
import { GeSpinner } from '../component/GeSpinner';
import { Header } from '../component/Header';
import { CartoucheButton } from '../component/CartoucheButton';
import { applyResult } from '../utils/applyResult';

export const ProfilVisitCardDelModal = (props: IModalProps) => {
    const { t } = useTranslation();

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const delFile = () => {
        setLoading(true);
        post('/mobile/visitCard/delete', {})
            .then((res) => {
                if (HTTPUtils.isSuccess(res)) {
                    applyResult(HTTPUtils.getResult(res), User._instance, true);

                    goBackTo(
                        props.navigation,
                        'Tab',
                        'ProfilVisitCardDelModal',
                    );

                    ToastManager.instance.addToast(
                        new Toast(t('profile_edit_success'), 5000, 'success'),
                    );
                } else {
                    setError(t(HTTPUtils.getError(res)) ?? '');
                    setLoading(false);
                }
            })
            .catch((err) => {
                setError(t('went_wrong_no_internet') ?? '');
                setLoading(false);
            });
    };

    return (
        <View style={styles.page}>
            <Header
                modal={true}
                title={t('delete_visit_card')}
                line={1}
                backButton={true}
                navigation={props.navigation}
                after={
                    <View
                        style={{
                            height: 10,
                        }}
                    ></View>
                }
                rounded={(User._instance.avatar.get() ?? '') !== ''}
                logo={User._instance.avatar.get() ?? ''}
                fallback={
                    <UserIcon
                        color={'white'}
                        size={35}
                    />
                }
            >
                <View
                    style={{
                        marginHorizontal: 20,
                    }}
                >
                    {loading ? (
                        <View
                            style={[
                                styles.boxCenter,
                                {
                                    height: height() * 0.5,
                                },
                            ]}
                        >
                            <GeSpinner color={getColor('primary')} />
                        </View>
                    ) : (
                        <View
                            style={{
                                paddingHorizontal: 20,
                            }}
                        >
                            <Text
                                style={{
                                    paddingVertical: 30,
                                    textAlign: 'center',
                                    fontFamily: FONT_REGULAR,
                                }}
                            >
                                {t('delete_visit_card_confirm')}
                            </Text>
                            {error !== '' && (
                                <Text
                                    style={[
                                        styles.textError,
                                        {
                                            marginTop: 10,
                                        },
                                    ]}
                                >
                                    {error}
                                </Text>
                            )}

                            <View
                                style={{
                                    marginTop: 10,
                                    marginBottom: 10,
                                }}
                            >
                                <CartoucheButton
                                    onPress={() => {
                                        delFile();
                                    }}
                                    color={getColor('error')}
                                    title={t('delete')}
                                    height={80}
                                />
                            </View>
                        </View>
                    )}
                </View>
            </Header>
        </View>
    );
};
